<span class="custom-tag hinted"
  [style.background]="backGroundColor"
  [style.color]="foreGroundColor"
  [ngClass]="{'search-margin': isSearch}">
  {{displayAbbr ? abbrName ? abbrName : tagName : tagName}}
  <div class="hint" *ngIf="displayAbbr">{{tagName}}</div>
  
  <i *ngIf="isRemove && !disabled" class="remove fa fa-close ml-2"
    [style.color]="foreGroundColor" (click)="remove()"></i>
</span>
